import React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Image from "mui-image";
import agency1 from "../../../assets/agency-1.webp";
import agency3 from "../../../assets/agency-3.webp";
import agency2 from "../../../assets/agency-2.webp";
import agency4 from "../../../assets/agency-4.webp";
import agency5 from "../../../assets/agency-5.webp";
import aws1 from "../../../assets/aws-1.webp";
import aws2 from "../../../assets/aws-2.webp";
import aws3 from "../../../assets/aws-3.webp";
import aws4 from "../../../assets/aws-4.webp";

const Award = () => {
  return (
    <section id="award" style={{ backgroundColor: "#ffffff" }}>
      <Container
        maxWidth="lg"
        sx={{ padding: { xs: "40px 0", sm: "40px 0", md: "130px 0 69px" } }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Grid container>
            <Grid item xs={12} md={12}>
              <Typography
                variant="h3"
                gutterBottom
                sx={{
                  textAlign: { xs: "center", sm: "center", md: "left" },
                  pb: 5,
                }}
              >
                Recent{" "}
                <span className="highlight-head">
                  Awards and Certifications
                </span>
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            sx={{ justifyContent: "space-around", my: 4, alignItems: "center" }}
          >
            <Grid xs={6} sm={4} md={2}>
              <Image src={agency1} width="172px" height={"auto"} />
            </Grid>
            <Grid xs={6} sm={4} md={2}>
              <Image src={agency2} width="192px" height={"auto"} />
            </Grid>
            <Grid xs={6} sm={4} md={2}>
              <Image src={agency3} width="100px" height={"auto"} />
            </Grid>
            <Grid xs={6} sm={4} md={2}>
              <Image src={agency4} width="172px" height={"auto"} />
            </Grid>
            <Grid xs={6} sm={4} md={2}>
              <Image src={agency5} width="172px" height={"auto"} />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            sx={{ pt: 5, display: "flex", justifyContent: "space-around" }}
          >
            <Grid
              item
              xs={6}
              sm={4}
              md={2.7}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "8px",
                border: "1px solid rgb(190, 225, 255)",
              }}
            >
              <Image src={aws1} width="100px" height={"auto"} />
            </Grid>
            <Grid
              item
              xs={6}
              sm={4}
              md={2.7}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "8px",
                border: "1px solid rgb(190, 225, 255)",
              }}
            >
              <Image src={aws2} width="100px" height={"auto"} />
            </Grid>
            <Grid
              item
              xs={6}
              sm={4}
              md={2.7}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "8px",
                border: "1px solid rgb(255, 224, 150)",
                pb: 2,
              }}
            >
              <Image src={aws3} width="100px" height={"auto"} />
            </Grid>
            <Grid
              item
              xs={6}
              sm={4}
              md={2.7}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "8px",
                border: "1px solid rgb(190, 225, 255)",
              }}
            >
              <Image src={aws4} width="100px" height={"auto"} />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </section>
  );
};

export default Award;
